var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.85704C21.825 8.72426 23.0864 8 24.5 8C26.9853 8 29 10.2386 29 13C29 15.7614 26.9853 18 24.5 18C24.266 18 24.0361 17.9802 23.8118 17.9419",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17H10C8.89543 17 8 17.8954 8 19V25H24V19C24 17.8954 23.1046 17 22 17H20.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17H29C30.1046 17 31 17.8954 31 19V23H24.5",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9357 9.77072C10.1102 8.6876 8.87739 8 7.5 8C5.01472 8 3 10.2386 3 13C3 15.7614 5.01472 18 7.5 18C7.7561 18 8.00721 17.9762 8.25162 17.9306",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H3C1.89543 17 1 17.8954 1 19V23H7.5",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUnit);
export default __webpack_public_path__ + "static/media/business-unit.7b3e4914c3986ff3a59b42c8f9f7b7e9.svg";
export { ForwardRef as ReactComponent };